import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { useShop } from "@/context/ShopContext";

const fmt = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(s / 3600)}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

export const CartTimer = ({ testid = "cart-timer", className = "" }) => {
  const { cartExpiresAt, cart } = useShop();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!cartExpiresAt) return undefined;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [cartExpiresAt]);
  if (!cartExpiresAt || !cart.length) return null;
  const left = new Date(cartExpiresAt) - now;
  const urgent = left < 30 * 60 * 1000;
  return (
    <div className={`flex items-center gap-2 rounded-xl border px-3 py-2 text-sm ${urgent ? "border-rose-400 bg-rose-50 text-rose-700" : "border-amber-500/40 bg-amber-50 text-stone-700"} ${className}`} data-testid={testid}>
      <Timer className="h-4 w-4 shrink-0" />
      <span>Prodotti riservati per te ancora <b className="font-mono" data-testid={`${testid}-left`}>{fmt(left)}</b>: completa l'ordine prima che il carrello si svuoti.</span>
    </div>
  );
};
